<template>
  <div
    class="l-select__option"
    :class="{
      'l-select__option--selected': isSelected,
      'l-select__option--hovered': index === select.aheadPointer
    }"
    @click="onSelect"
    @mouseover="onHover"
  >{{ label }}</div>
</template>

<script>
export default {
  name: "LOption",

  inject: ["select"],

  props: {
    value: [String, Number],
    label: [String, Number],
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    isSelected() {
      if (this.select.multiple) {
        return !!this.select.selected.find(item => item.value === this.value);
      } else {
        return this.select.value === this.value;
      }
    },
    index() {
      if (!Array.isArray(this.select.data) || !this.select.data.length) return;
      return this.select.data.findIndex(item => item.value === this.value);
    }
  },

  methods: {
    onSelect() {
      this.select.$emit("option:select", {
        value: this.value,
        label: this.label,
        disabled: this.disabled
      });
    },
    onHover() {
      this.select.aheadPointer = this.index;
    }
  }
};
</script>

<style lang="postcss">
.l-select__option {
  @apply cursor-pointer;
  @apply text-xs text-pastel-black;
  @apply pt-2 pb-2 pl-3 pr-3 mt-0 mb-0 -mr-2 -ml-2;
}
.l-select__option--hovered {
  @apply bg-gray-100;
}
.l-select__option--selected {
  @apply text-pastel-green-500;
}
.l-select__option--selected:hover {
  @apply bg-green-100;
}
</style>
